import client from "./client";

export interface Photo {
  id: number;
  userId: number;
  templateId: number;
  questionTxt: string;
  url: string;
  description: string;
  /** Encoded PhotoLayout string (see components/PhotoPage/photoPresets.ts).
   *  Legacy values: "top" | "center" | "bottom" | "vertical" | "square" | "horizontal" */
  position: string;
  showDate: boolean;
  showDescription: boolean;
  createdAt: string;
}

export const photosApi = {
  getByTemplate: (templateId: number) =>
    client.get<Photo[]>(`/photos/${templateId}`),

  create: (data: {
    templateId: number;
    url: string;
    description?: string;
    position?: string;
    questionTxt?: string;
  }) => client.post<Photo>("/photos", data),

  update: (id: number, data: Partial<Photo>) =>
    client.patch<Photo>(`/photos/${id}`, data),

  remove: (id: number) =>
    client.delete(`/photos/${id}`),
};
